import Vue from 'vue';
import cashDeposit from './cash-deposit/cash-deposit.vue';
Vue.component('cash-deposit', cashDeposit);
